import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5072/api';

const API = axios.create({
  baseURL: apiUrl,
});

// Her istekte localStorage'daki siteId'yi header olarak gönder
API.interceptors.request.use(config => {
  const k = localStorage.getItem('kullanici');
  if (k) {
    const kullanici = JSON.parse(k);
    if (kullanici.siteId) config.headers['X-Site-Id'] = kullanici.siteId;
    if (kullanici.dokKod) config.headers['X-Dok-Kod'] = kullanici.dokKod;
  }
  return config;
});

// Auth
export const getSiteId = () => {
  const params = new URLSearchParams(window.location.search);
  return parseInt(params.get('siteId')) || 0;
};
export const girisYap = (kullaniciAdi, parola, siteId) => API.post('/Auth/giris', { kullaniciAdi, parola, siteId });
export const sifreDegistir = (siteId, noo, eskiParola, yeniParola) =>
  API.post('/Auth/sifre-degistir', { siteId, noo, eskiParola, yeniParola });

// Dashboard
export const getDashboardOzet = () => API.get('/Dashboard/ozet');

// Hasta
export const getHastaSayisi = () => API.get('/Hasta/sayi');
export const getHastalar = (ara) => API.get('/Hasta', { params: { ara } });
export const getHasta = (kayitNo) => API.get(`/Hasta/${kayitNo}`);
export const yeniHasta = (data) => API.post('/Hasta', data);
export const guncelleHasta = (kayitNo, data) => API.put(`/Hasta/${kayitNo}`, data);
export const getTemelMedikal = (kayitNo) => API.get(`/Hasta/${kayitNo}/temel-medikal`);
export const getPersantil = (kayitNo) => API.get(`/Hasta/${kayitNo}/persantil`);
export const getDokumanlar = (kayitNo) => API.get(`/Hasta/${kayitNo}/dokumanlar`);
export const getDokumanBlob = (id) => API.get(`/Hasta/dokumanlar/${id}`, { responseType: 'blob' });
export const getAsilar = (kayitNo) => API.get(`/Hasta/${kayitNo}/asilar`);

// Fotoğraf
export const getFotoUrl = (kayitNo) => `${apiUrl}/Hasta/${kayitNo}/foto`;
export const uploadFoto = (kayitNo, blob) => {
  const form = new FormData();
  form.append('dosya', blob, 'foto.jpg');
  return API.post(`/Hasta/${kayitNo}/foto`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Randevu
export const getRandevular = (bas, bit, dokKod) => API.get('/Randevu', { params: { bas, bit, dokKod } });
export const iptalEtRandevu = (siteId, id, whoNo, who, gerekce) =>
  API.post('/Randevu/iptal', { siteId, id, whoNo, who, gerekce });
export const getDoktorlarPanel = (siteId) => API.get('/Randevu/doktorlar', { params: { siteId } });
export const getSiteAyar = (siteId) => API.get('/Randevu/site-ayar', { params: { siteId } });

// Muayene
export const getMuayeneler = (bas, bit) => API.get('/Muayene', { params: { bas, bit } });
export const getHastaMuayeneleri = (kayitNo) => API.get(`/Muayene/hasta/${kayitNo}`);
export const getMuayene = (id) => API.get(`/Muayene/${id}`);
export const yeniMuayene = (data) => API.post('/Muayene', data);

// Lookup (combo kaynakları)
export const getKurum = () => API.get('/Lookup/kurum');
export const getUlkeler = () => API.get('/Lookup/ulkeler');
export const getGelisTuru = () => API.get('/Lookup/gelis-turu');
export const getIller = () => API.get('/Lookup/iller');
export const getIlceler = (ilId) => API.get('/Lookup/ilceler', { params: { ilId } });
export const getAnamnezBasliklar = () => API.get('/Lookup/anamnez-basliklar');

export default API;
